// extracted by mini-css-extract-plugin
export default {"CustomSelect":"CustomReactSelect_CustomSelect__czSIN"};